module.exports = __webpack_public_path__ + "static/media/laurel.3b6b420f.webp";